import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Recuperar contraseña"
      subtitle="Introduzca su email profesional y le enviaremos un enlace para restablecer la contraseña."
      footer={<Link to="/acceso" style={{ color: "var(--burgundy)", textDecoration: "none", fontWeight: 600 }}>Volver a acceso</Link>}
    >
      {done ? (
        <p data-testid="forgot-done" style={{ textAlign: "center", color: "var(--muted)", lineHeight: 1.6, margin: 0 }}>
          Si el correo existe, recibirá instrucciones para restablecer su contraseña.
        </p>
      ) : (
        <form onSubmit={submit} data-testid="forgot-form">
          <label className="ddp-label">Email profesional</label>
          <input type="email" className="ddp-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" required />
          <button type="submit" disabled={loading} data-testid="forgot-submit" className="ddp-btn ddp-btn-primary" style={{ width: "100%", marginTop: 24 }}>
            {loading ? "Enviando…" : "Enviar enlace"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
